import request from '@/utils/request'

const prefix = '/django_rest/super-admin'

export default {
  getSuperAdminCompanyList (params) {
    return request.get(`${prefix}/company/`, { params })
  },
  getHRAccountList (params) {
    return request.get(`${prefix}/hr-account/`, { params })
  }
}
